import { styled } from 'styled-components'

export const Root = styled.div<{ $variant: 'gray' }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Title = styled.div`
  font-weight: bold;
  font-size: 32px;
  color: #cacaca;
`

export const Actions = styled.div``
